document.addEventListener('DOMContentLoaded', function() {
  
    const targetNode = document.querySelector('.productView-price.no-js-hidden.clearfix');
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                let newPrices = document.querySelectorAll('.productView-price.no-js-hidden.clearfix .price__last');
                if (newPrices.length > 1) {
                    let secondElement = newPrices[1];
                    let priceElement = secondElement.querySelector('.price-item.price-item--sale');
                    if (priceElement) {
                        let textContent = priceElement.textContent;
                        let priceMatch = textContent.match(/[\d,]+\.\d{2}/);
                        if (priceMatch) {
                            let newPrice = priceMatch[0].replace(/,/g, '') * 100;
                            $('.affirm-as-low-as').attr('data-amount', newPrice);
                            affirm.ui.refresh()
                        } else {
                            console.log('Price match not found');
                        }
                    } else {
                        console.log('price-item not found');
                    }
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
});
